import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import "./ServiceList.css";
import { Service, TopSection } from "../../Components";
import { Container } from "react-bootstrap";
import image1 from "../../Assets/Images/service-list/1.png";
import image2 from "../../Assets/Images/service-list/2.png";
import image3 from "../../Assets/Images/service-list/3.png";
import image4 from "../../Assets/Images/service-list/4.png";
import image5 from "../../Assets/Images/service-list/5.png";
import image6 from "../../Assets/Images/service-list/6.png";

const ServiceList = ({ url, data ,language,translations,services,servicesData}) => {
  const navigate = useNavigate(); 
  const ServiceTitle = servicesData?.page_title;
  const ServiceDes = servicesData?.page_description;
  const [visibleServices, setVisibleServices] = useState(9); 
  

  const handleServiceClick = (serviceName) => {
    navigate(`/details/${encodeURIComponent(serviceName)}`);
  };

  const handleShowMore = () => {
    setVisibleServices(services.length); 
  };

  return (
    <div>
      <TopSection
        desc={translations?.result?.InteriorDesign}
        title={`${translations?.result?.home} / ${translations?.result?.Services}`}
        subtitle={`/${translations?.result?.InteriorDesign}`}
        image={require("../../Assets/Images/top-sections/services-top.png")}
      />
      <Container>
        <div className="service-list-title">{ServiceTitle}</div>
        <div
          className="service-list-para"
          dangerouslySetInnerHTML={{ __html: ServiceDes }}
        ></div>
        <div className="service-list-content">
          {services.slice(0, visibleServices).map((service, index) => {
            const mainImage = service.gallery.find(item => item.main_image === 1);
            return (
              <Service
                key={index}
                onClick={() => handleServiceClick(service.service_name)} 
                image={mainImage ? url + mainImage.link : require("../../Assets/Images/service-list/1.png")}  
                title={language === "en" ? service.service_name || "" : service.service_name_ar || ""}
              />
            );
          })}
        </div>
        {visibleServices < services.length && (
          <div className="service-list-link">
            <a 
              className="border-animation" 
              onClick={handleShowMore}
              style={{ cursor: 'pointer' }}
            >
              {translations?.result?.ShowMore}
            </a>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ServiceList;
